import React from 'react';
import './country.css';

const countries = [
  { name: 'United Kingdom', flag: 'https://flagcdn.com/gb.svg', link: 'form' },
  { name: 'United States', flag: 'https://flagcdn.com/us.svg', link: 'us' },
  { name: 'Canada', flag: 'https://flagcdn.com/ca.svg', link: 'canada' },
  { name: 'Australia', flag: 'https://flagcdn.com/au.svg', link: 'australia' },
  { name: 'New Zealand', flag: 'https://flagcdn.com/nz.svg', link: 'newzealand' },
  { name: 'Europe', flag: 'https://flagcdn.com/eu.svg', link: 'europe' },
  { name: 'Russia', flag: 'https://flagcdn.com/ru.svg', link: 'russia' },
  { name: 'Switzerland', flag: 'https://flagcdn.com/ch.svg', link: 'switzerland' },
  { name: 'Dubai', flag: 'https://flagcdn.com/ae.svg', link: 'dubai' },
  { name: 'Ireland', flag: 'https://flagcdn.com/ie.svg', link: 'ireland' },
  { name: 'Singapore', flag: 'https://flagcdn.com/sg.svg', link: 'singapore' },
  { name: 'Germany', flag: 'https://flagcdn.com/de.svg', link: 'germany' },
];

const CountryGrid = () => {
  const firstRowCountries = countries.slice(0, 6);
  const secondRowCountries = countries.slice(6, 12);

  return (
    <div className="page-container">
      <h1 className="title">Countries We Work With</h1>

      <div className="scroll-container">
        <div className="scroll-row scroll-left">
          {[...firstRowCountries, ...firstRowCountries].map((country, index) => (
            <div className="country-card" key={index}>
              <img src={country.flag} alt={country.name} className="flag" />
              <h3>{country.name}</h3>
            </div>
          ))}
        </div>
      </div>

      <div className="scroll-container">
        <div className="scroll-row scroll-right">
          {[...secondRowCountries, ...secondRowCountries].map((country, index) => (
            <div className="country-card" key={index}>
              <img src={country.flag} alt={country.name} className="flag" />
              <h3>{country.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CountryGrid;
